import { useContext, useState } from "react";
import { ensure, mapToNamedProperty } from "sprint-common-web";

import { DeliveryEndpointsDataContext } from "../../../../../common/data/lookup-data-providers/DeliveryEndpointsDataProvider";
import { DistributionList } from "../../../../../common/data/lookup-data-providers/DistributionListsDataProvider";
import { DeliveryEndpointType } from "../../../../../common/types/DeliveryEndpointType";
import { useAdminAirlineApi } from "../../../../airline/common/api/useAdminAirlineApi";
import { ensureSmartjogDetails } from "../../../../delivery-endpoint/edit/smartjog/EditSmartjogDeliveryEndpointForm";
import { SystemPlatformDetailsContext } from "../../context/SystemPlatformDetailsContext";
import { useDeliveryInfo } from "../useDeliveryInfo";
import { EditSmartjogDeliveryInfoFormInputs } from "./EditSmartjogDeliveryInfoForm";

export const useEditSmartjogDeliveryInfoForm = () => {
    const { updateDeliveryInfo } = useAdminAirlineApi();
    const { deliveryEndpoint } = useDeliveryInfo();

    const { systemPlatformDetailsItem, updateDeliveryInfo: updateDeliveryInfoItem } = useContext(
        SystemPlatformDetailsContext
    );
    const { deliveryEndpoints } = useContext(DeliveryEndpointsDataContext);

    const [distributionLists, setDistributionLists] = useState<DistributionList[]>([]);

    const smartjogDeliveryEndpoints = deliveryEndpoints.filter(
        (item) =>
            item.type === DeliveryEndpointType.Smartjog &&
            item.integrator.id === systemPlatformDetailsItem.integrator.id
    );

    const itemToEdit = {
        deliveryEndpoint: deliveryEndpoint,
        distributionList: systemPlatformDetailsItem.deliveryInfo.distributionList,
        type: deliveryEndpoint?.type
    };

    const editSmartjogDeliveryInfo = async ({
        deliveryEndpointId,
        distributionListId
    }: EditSmartjogDeliveryInfoFormInputs) => {
        await updateDeliveryInfo({
            airlineId: systemPlatformDetailsItem.airline.id,
            systemId: systemPlatformDetailsItem.system.id,
            deliveryEndpointId,
            distributionListId: Number(distributionListId)
        });

        const endpoint = deliveryEndpoints.find((item) => item.id === deliveryEndpointId);
        ensure(endpoint);
        ensureSmartjogDetails(endpoint.details);

        const distributionList = endpoint.details.distributionLists.find(
            (item) => item.id === Number(distributionListId)
        );
        ensure(distributionList);

        updateDeliveryInfoItem({
            deliveryEndpoint: mapToNamedProperty(endpoint),
            distributionList: mapToNamedProperty(distributionList)
        });
    };

    const resetDistributionListOptions = (deliveryEndpointId: string) => {
        const endpoint = deliveryEndpoints.find((item) => item.id === deliveryEndpointId);
        ensure(endpoint);
        ensureSmartjogDetails(endpoint.details);

        setDistributionLists(endpoint.details.distributionLists);
    };

    return {
        itemToEdit,
        deliveryEndpoints: smartjogDeliveryEndpoints,
        distributionLists,
        editSmartjogDeliveryInfo,
        resetDistributionListOptions
    };
};
